var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskicon7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#DCFCE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6 31.62L17.8667 27.36L19.8 25.62L22.6 28.14L28.2 23.1L30.1333 24.84L22.6 31.62ZM14.6667 36C13.9333 36 13.3056 35.765 12.7833 35.295C12.2611 34.825 12 34.26 12 33.6V16.8C12 16.14 12.2611 15.575 12.7833 15.105C13.3056 14.635 13.9333 14.4 14.6667 14.4H16V12H18.6667V14.4H29.3333V12H32V14.4H33.3333C34.0667 14.4 34.6944 14.635 35.2167 15.105C35.7389 15.575 36 16.14 36 16.8V33.6C36 34.26 35.7389 34.825 35.2167 35.295C34.6944 35.765 34.0667 36 33.3333 36H14.6667ZM14.6667 33.6H33.3333V21.6H14.6667V33.6ZM14.6667 19.2H33.3333V16.8H14.6667V19.2Z",
    fill: "#0D9488"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskicon7);
export default __webpack_public_path__ + "static/media/taskicon7.dc0075e0a75da58999142437f37d11a2.svg";
export { ForwardRef as ReactComponent };